define('app/filters/controls/BetweenFilterControl',['require','./InFilterControl','app/visualizations/FormatFactory','glu/util','glu/$','moment','hbs!./BetweenFilterControl.hbs'],function(require) {
	'use strict';

	var InFilterControl = require('./InFilterControl'),
		FormatFactory = require('app/visualizations/FormatFactory'),
		_ = require('glu/util'),
		$ = require('glu/$'),
		moment = require('moment');

	return InFilterControl.extend({
		template: require('hbs!./BetweenFilterControl.hbs'),
		tagName: 'span',

		ui: {
			$minVal: '[name=minValue]',
			$maxVal: '[name=maxValue]',
			$errorMsg: '[id=errorMsg]',
			$startHour: '#start-time-hour',
			$startMinute: '#start-time-minute',
			$startAMPM: '#start-time-ampm',
			$endHour: '#end-time-hour',
			$endMinute: '#end-time-minute',
			$endAMPM: '#end-time-ampm'
		},

		events: {
			'change [name=minValue]': 'updateModel',
			'change [name=maxValue]': 'updateModel',
			'keyup [name=minValue]': 'updateModel',
			'keyup [name=maxValue]': 'updateModel',
			'change [id^="start-"]': 'updateModelValues',
			'change [id^="end-"]': 'updateModelValues'
		},
		serializeData: function() {
			return this;
		},

		initialize: function() {
			this.model.setArity(2);
			this.setStaticValues();
		},

		onRender: function() {
			if (this.isTime()) {
				this.setTimeValues();
			} else {
				if ($(this.ui.$minVal) && this.minValue()) {
					$(this.ui.$minVal).val(this.minValue());
				}
				if ($(this.ui.$maxVal) && this.maxValue()) {
					$(this.ui.$maxVal).val(this.maxValue());
				}
			}

			this.updateModelValues();
		},

		minValue: function() {
			var value = this.model.getValue(0);
			return (value === null || value === undefined) ? null : value.toString();
		},

		maxValue: function() {
			var value = this.model.getValue(1);
			return (value === null || value === undefined) ? null : value.toString();
		},

		minLabel: function() {
			var format = FormatFactory.formatterForType(this.model.type(), {
				enumeration: this.model.enumeration(),
				displayFormat: this.model.getDisplayFormat()
			});
			return format(this.minValue());

		},

		maxLabel: function() {
			var format = FormatFactory.formatterForType(this.model.type(), {
				enumeration: this.model.enumeration(),
				displayFormat: this.model.getDisplayFormat()
			});
			return format(this.maxValue());
		},

		minSelectableOptions: function() {
			var self = this;
			var selectableOptions = this.possibleValues();

			_.each(selectableOptions, function(pv) {
				_.extend(pv, {
					isSelected: self.minValue() === pv.value
				});
			});

			return selectableOptions;
		},

		maxSelectableOptions: function() {
			var self = this;
			var selectableOptions = this.possibleValues();

			_.each(selectableOptions, function(pv) {
				_.extend(pv, {
					isSelected: self.maxValue() === pv.value
				});
			});

			return selectableOptions;
		},

		updateModel: function() {
			var minInputValue = this.ui.$minVal.val();
			var maxInputValue = this.ui.$maxVal.val();

			if (isNaN(minInputValue) || isNaN(maxInputValue)) {
				this.ui.$errorMsg.show();
			} else {
				this.ui.$errorMsg.hide();
			}

			// validate the fields
			if (isNaN(minInputValue)) {
				this.ui.$minVal.addClass('input-dialog-item-error');
			} else {
				this.ui.$minVal.removeClass('input-dialog-item-error');
			}

			if (isNaN(maxInputValue)) {
				this.ui.$maxVal.addClass('input-dialog-item-error');
			} else {
				this.ui.$maxVal.removeClass('input-dialog-item-error');
			}

			var minValue = parseFloat(minInputValue);
			var maxValue = parseFloat(maxInputValue);
			this.model.setValue(0, minInputValue && minInputValue.length === 0 || isNaN(minInputValue) ? null : minValue);
			this.model.setValue(1, maxInputValue && maxInputValue.length === 0 || isNaN(maxInputValue) ? null : maxValue);
		},

		isTime: function() {
			return this.model.get('fieldObject') && this.model.get('fieldObject').get('displayFormat') === 'time';
		},

		setStaticValues: function() {
			var hours = [];
			var minutes = [];
			var string = '';

			for (var i = 1; i < 13; i++) {
				hours.push(String(i));
			}

			for (var j = 0; j < 60; j++) {
				if (String(j).length === 1) {
					string = '0' + j;
				} else {
					string = j;
				}
				minutes.push(string);
			}

			this.hours = hours;
			this.minutes = minutes;
		},

		setTimeValues: function() {
			var startHours = 0,
				startMinutes = 0,
				startAmpm = 'am',
				endHours = 0,
				endMinutes = 0,
				endAmpm = 'am';

			if (this.model.getValues()[0]) {
				startHours = moment().startOf('day').add(this.model.getValues()[0], 'minutes').format('h');
				startMinutes = moment().startOf('day').add(this.model.getValues()[0], 'minutes').format('mm');
				startAmpm = moment().startOf('day').add(this.model.getValues()[0], 'minutes').format('a');
			} else {
				startHours = '12';
				startMinutes = '00';
			}

			if (this.model.getValues()[1]) {
				endHours = moment().startOf('day').add(this.model.getValues()[1], 'minutes').format('h');
				endMinutes = moment().startOf('day').add(this.model.getValues()[1], 'minutes').format('mm');
				endAmpm = moment().startOf('day').add(this.model.getValues()[1], 'minutes').format('a');
			} else {
				endHours = '12';
				endMinutes = '00';
			}

			$(this.ui.$startAMPM).val(startAmpm);
			$(this.ui.$startHour).val(startHours);
			$(this.ui.$startMinute).val(startMinutes);

			$(this.ui.$endAMPM).val(endAmpm);
			$(this.ui.$endHour).val(endHours);
			$(this.ui.$endMinute).val(endMinutes);
		},

		updateModelValues: function() {
			var startMinutes = 0,
				startHours = 0,
				totalStartMinutes = 0,
				endMinutes = 0,
				endHours = 0,
				totalEndMinutes = 0;

			if ($(this.ui.$startHour).val() && $(this.ui.$startMinute).val() && $(this.ui.$startAMPM).val()) {
				startHours = parseInt($(this.ui.$startHour).val(), 10);
				startMinutes = parseInt($(this.ui.$startMinute).val(), 10);

				if ($(this.ui.$startAMPM).val() === 'pm' && startHours < 12) {
					startHours = parseInt(startHours, 10) + 12;
				}
				if ($(this.ui.$startAMPM).val() === 'am' && startHours === 12) {
					startHours = 0;
				}

				totalStartMinutes = startMinutes + (startHours * 60);

				this.model.setValue(0, totalStartMinutes);
			}

			if ($(this.ui.$endHour).val() && $(this.ui.$endMinute).val() && $(this.ui.$endAMPM).val()) {
				endHours = parseInt($(this.ui.$endHour).val(), 10);
				endMinutes = parseInt($(this.ui.$endMinute).val(), 10);

				if ($(this.ui.$endAMPM).val() === 'pm' && endHours < 12) {
					endHours = parseInt(endHours, 10) + 12;
				}
				if ($(this.ui.$endAMPM).val() === 'am' && endHours === 12) {
					endHours = 0;
				}

				totalEndMinutes = endMinutes + (endHours * 60);

				this.model.setValue(1, totalEndMinutes);
			}
		}
	});

});

